import React, {Component} from 'react';

import Paging from '../../../Buttons/PagingBtn/index';
import * as AdminHomeworkService from '../../../../services/Teacher/AdminHomeworkService';
import PopupAdminReading from "../../../Containers/PopupAdminReading";
import Loading from "../../../Containers/Loading";

class AdminReading extends Component {
    state = {
        isPopupAdminReading: false,
        popupAdminReading: {
            fileName: '',
            grade: '',
            section: '',
            title: '',
            contents: '',
        },
        readingList: [],
        // loading
        isLoadingHide: true
    }

    constructor(props) {
        super(props);
        // this.sortSizeList = [
        //     {id: 0, text: "전체 보기", value: 1000000},
        //     {id: 1, text: "30개씩 보기", value: 30},
        //     {id: 2, text: "50개씩 보기", value: 50},
        // ];
        // this.sortSizeValue = 30;
    }

    componentDidMount = () => {
        this.getReadingList();
    }

    getReadingList = () => {
        AdminHomeworkService.getReadingList().then(response => {
            if (response !== null && response.status === 200 && response.data !== null && response.data.code === '0000') {
                this.setState({
                    readingList: response.data.data
                });
            } else {
                console.log(response);
                alert('FAILED');
            }
        }).catch(error => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    openPopupAdminReading = () => {
        this.setState({
            popupAdminReading: {
                fileName: '',
                grade: '',
                section: '',
                title: '',
                contents: '',
            },
            isPopupAdminReading: true
        });
    }
    closePopupAdminReading = () => {
        this.setState({
            isPopupAdminReading: false
        });
    }

    saveReadingData = (data) => {
        this.setState({
            isLoadingHide: false,
            popupAdminReading: {
                fileName: data['fileName'],
                grade: data['grade'],
                section: data['section'],
                title: data['title'],
                contents: data['contents'],
            },
        });
        AdminHomeworkService.saveReading(data).then((response) => {
            if (response !== null && response.status === 200) {
                // 데이터 저장 성공
                if (response.data !== null && response.data.code === '0000') {
                    alert('SUCCESS');
                    this.getReadingList();
                } else {
                    alert('ERROR > ' + response.data.data);
                }
            } else {
                console.log(response);
                alert('READING SAVE ERROR');
            }
            this.setState({
                isLoadingHide: true,
                isPopupAdminReading: false
            });
        }).catch(error => {
            console.log(error);
            alert('SERVER ERROR');
            this.setState({
                isLoadingHide: true
            });
        });
    }

    deleteBtn = () => {
        console.log('delete');
    }

    renderReadingList = () => {
        const renderReadingList = this.state.readingList.map((item, index) =>
            <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.grade}</td>
                <td>{item.section}</td>
                <td>{item.title}</td>
                <td style={{textAlign:'left'}}><span>{item.contents}</span></td>
                <td>
                    <a className="btn-sm deepPink" onClick={() => this.deleteBtn(index)}>삭제</a>
                </td>
            </tr>
        );
        return renderReadingList;
    }

    renderPopupAdminReading = () => {
        return (
            <div className="wrap-rCon">
                <PopupAdminReading
                    fileName={this.state.popupAdminReading.fileName}
                    grade={this.state.popupAdminReading.grade}
                    section={this.state.popupAdminReading.section}
                    title={this.state.popupAdminReading.title}
                    contents={this.state.popupAdminReading.contents}
                    closePopup={this.closePopupAdminReading} readingSaveData={this.saveReadingData}/>
            </div>
        );
    }

    renderAdminReading = () => {
        return (
            <div className="wrap-rCon">
                <div className="wrap-top">
                    <a className="baseBtn undefined blue" onClick={this.openPopupAdminReading}><span>읽기 저장하기</span></a>
                    <div className="box-rfix">
                        <div className="wrap-search">
                            <input className="ip-basic" type="text" placeholder="읽기 검색"/>
                            <a className="btn-sm yellow">검색</a>
                        </div>
                    </div>
                </div>

                <div className="tb-scroll">
                    <table className="tb-basic">
                        <colgroup>
                            <col width="10%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="20%"/>
                            <col width="15%"/>
                        </colgroup>
                        <thead>
                        <tr>
                            <th>번호</th>
                            <th>대목차</th>
                            <th>소목차</th>
                            <th>제목</th>
                            <th>Contents</th>
                            <th>수정</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderReadingList()}
                        </tbody>
                    </table>
                </div>
                <Paging currentPage={this.curPage} totalPages={this.totalPages} onUpdatePage={this.onUpdatePage}/>
            </div>
        );
    }

    render() {
        return (
            !this.state.isLoadingHide ? <Loading/> : this.state.isPopupAdminReading ? this.renderPopupAdminReading() : this.renderAdminReading()
        );
    }
}

export default AdminReading;


// WEBPACK FOOTER //
// ./src/components/Pages/Teacher/AdminSystem/AdminReading.js